import { Directive, Input, Optional } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS, ValidationErrors, NgForm } from '@angular/forms';

@Directive({
    selector: '[startEndEventValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: StartEndEventValidatorDirective,
            multi: true,
        },
    ],
})
export class StartEndEventValidatorDirective implements Validator {
    @Input('startEndEventValidator')
    secondControlName: string;

    constructor(@Optional() private form: NgForm) {}

    validate(control: AbstractControl<any, any>): ValidationErrors {
        if (!control || !control.value || !this.form || !this.secondControlName) {
            return null;
        }

        // Get the second control from the form by name
        const secondControl: AbstractControl = this.form.form?.get(this.secondControlName);
        if (!secondControl || !secondControl.value) {
            return null;
        }

        if (control.value == secondControl.value) {
            return { startEndEventInvalid: true };
        } else {
            secondControl.setErrors(null);
        }

        return null;
    }
}
